import { HttpClient, HttpHeaders, HttpErrorResponse, HttpEvent } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { delay } from 'rxjs/operators';
import { EnvironmentService } from '../environment/environment.service';
import { DataConnectorType, DataConnectorTypeIngest, FtpService } from 'src/app/domainObjects/dataConnector';
import { DataTransformerConfig } from 'src/app/domainObjects/dataTransformConfig';
import { DataSourceType } from 'src/app/domainObjects/dataSourceType';
import { ColumnDefinition } from 'src/app/domainObjects/columnDefinition';
import { BrowseFolderRequest, BrowseFolderSelectRequest, BrowseParquetPartitionFolderRequest } from 'src/app/messaging/browseFolderRequest';
import { GetColumnsRequest } from 'src/app/messaging/getColumnsRequest';
import { BrowseFolderResponse } from 'src/app/messaging/browseFolderResponse';
import { ImportDataResponse } from 'src/app/messaging/importDataResponse';
import { PreviewDataImportRequest } from 'src/app/messaging/previewImportDataRequest';
import { FileNode } from 'src/app/objectModel/fileNode';
import { RunConfigRequest, RunCurrentConfigRequest } from 'src/app/messaging/runConfigRequest';
import { GetDataFarmPreviewIngestRequest, GetDataFarmPreviewRequest, SaveIngestDataRequest } from '../../messaging/getDataFarmPreviewRequest';
import { GetDataFarmPreviewResponse } from '../../messaging/getDataFarmPreviewResponse';
import { GetExcelSheetNamesRequest, GetFeatherFileRequest, GetParquetFileRequest } from '../../messaging/getExcelSheetNamesRequest';
import { DetectDelimiterResponse } from 'src/app/messaging/detectDelimiterResponse';
import { DetectDelimiterRequest } from 'src/app/messaging/detectDelimiterRequest';
import { DataRefineryConfig, TableRefinery, RefineryConflictError } from 'src/app/domainObjects/dataRefineryConfig';
import { Edge } from '@swimlane/ngx-graph';
import { FarmConverterRule } from 'src/app/domainObjects/transformers/farmConverterTransform';
import { MasterConfig } from 'src/app/domainObjects/masterConfig';
import { RunrefineryResponse } from 'src/app/model/RunrefineryResponse';
import { ResetTransformerRequest, ResetTransformerResponse, RunrefineryRequest, UpdateNodesStatusRequest } from 'src/app/model/RunrefineryRequest';
import { ReadRefineryRequest } from 'src/app/model/ReadRefineryRequest';
import { ReadRefineryResponse } from 'src/app/model/ReadRefineryResponse';
import { ImportRefineryResponse } from 'src/app/model/ImportRefineryResponse';
import { ImportRefineryError } from 'src/app/model/ImportRefineryError';
import { ExportDataFileResponse, ExportViewModel } from 'src/app/viewModels/exportViewModel';
import { DataWriterMapRequest, ExportMapColumnInfo, JsonFormData, OutputCoulumnRequest, OutputCoulumnResponse, OutputCoulumnsMappings, OutputCoulumnsMappingsResponse, PartitionCoulumnRequest, PartitionCoulumnResponse, TestDataWriterRequest, TestDataWriterResponse, TestWriterRequest } from 'src/app/views/transform/export-output-data-dynamic/export-output-data-dynamic.component';
import { UserDataService } from '../user-data-service';
import { JoinerListRequest, JoinerListResponse } from 'src/app/views/transform/transformerDetail/joiner-transform-detail/joinerViewModel';
import { AuthService } from 'src/app/auth.service';
import { GetFilteredselcolvalsRequest } from 'src/app/messaging/getFilteredselcolvalsRequest';
import { GetFilteredselcolvalsResponse } from 'src/app/messaging/getFilteredselcolvalsResponse';
import { UpdateIngestNodesStatusRequest } from 'src/app/messaging/updateIngestNodesStatusRequest';
import { UpdateIngestNodeStatusResponse } from 'src/app/messaging/updateIngestNodeStatusResponse';
import { IngestTreeNode, IngestUploadLimits, IngestUploadResult } from 'src/app/messaging/ingestFile';
import { TestSendEmailRequest, TestSendEmailResponse } from 'src/app/views/email-sender/email-sender.component';
import { DatabaseConnectorTestConnectionRequest, DataConnectorCountResponse, DataConnectorTestConnectionResponse, RecentAvailableDateResponse } from 'src/app/views/connectors/database/sql-data-connector/sql-data-connector.component';
import { OracleDataConnectorTestConnectionRequest } from 'src/app/views/connectors/database/oracle-data-connector/oracle-data-connector.component';
import { MySqlDataConnectorTestConnectionRequest } from 'src/app/views/connectors/database/mysql-data-connector/mysql-data-connector.component';
import { VerticaDataConnectorTestConnectionRequest } from 'src/app/views/connectors/database/vertica-data-connector/vertica-data-connector.component';
import { GetSummaryDataFarmPreviewRequest, GetSummaryEmptyColslistResponse } from 'src/app/messaging/getSummaryDataFarmPreviewRequest';
import { SaveCurrntTransfrmcacheRequest } from 'src/app/messaging/saveCurrntTransfrmcacheRequest';
import { SaveCurrntTransfrmcacheResponse } from 'src/app/messaging/saveCurrntTransfrmcacheResponse';
import { CacheStatusRequest, CacheStatusResponse, ResetNodeStatusRequest, ResetNodeStatusResponse, ResetRefineryNodesStatusRequest } from 'src/app/messaging/resetRefineryNodesStatusRequest';
import { ResetRefineryNodesStatusResponse } from 'src/app/messaging/resetRefineryNodesStatusResponse';
import { TestFTPConnectionResponse } from 'src/app/messaging/testFTPConnectionResponse';
import { CreateMasterColMappingsRequest } from 'src/app/messaging/createMasterColMappingsRequest';
import { CreateMasterColMappingsResponse } from 'src/app/messaging/createMasterColMappingsResponse';
import { GetUnifiedColmappingMapLibRequest } from 'src/app/messaging/getUnifiedColmappingMapLibRequest';
import { GetUnifiedColmappingMapLibResponse } from 'src/app/messaging/getUnifiedColmappingMapLibResponse';
import { GetTotalPartitionedFoldersRequest } from 'src/app/messaging/getTotalPartitionedFoldersRequest';
import { GetTotalPartitionedFoldersResponse } from 'src/app/messaging/getTotalPartitionedFoldersResponse';
import { GetDefaultIngestNodePathRequest } from 'src/app/messaging/getDefaultIngestNodePathRequest';
import { GetDefaultIngestNodePathResponse } from 'src/app/messaging/getDefaultIngestNodePathResponse';
import { SetDefaultIngestNodePathRequest } from 'src/app/messaging/setDefaultIngestNodePathRequest';
import { GetDefaultParquetPartitionedIngestNodePathRequest } from 'src/app/messaging/getDefaultParquetPartitionedIngestNodePathRequest';
import { ValidateParquetPartitionedIngestNodePathRequest } from 'src/app/messaging/validateParquetPartitionedIngestNodePathRequest';
import { ValidateParquetPartitionedIngestNodePathResponse } from 'src/app/messaging/validateParquetPartitionedIngestNodePathResponse';

interface FileExistCheckResponse {
  fileExistsStatus: boolean;
  message?: string;
}
export class DataConnectorOptionItem {
  title: string;
  subtitle: string;
  dataConnectorType: DataConnectorType;
  icon: string;
  isSelected: boolean;

  constructor(connectorType: DataConnectorType, title: string, subtitle: string, icon: string) {
    this.title = title;
    this.subtitle = subtitle;
    this.icon = icon;
    this.dataConnectorType = connectorType;
  }
}
export class DataConnectorOptionItemIngest {
  title: string;
  subtitle: string;
  dataConnectorTypeIngest: DataConnectorTypeIngest;
  icon: string;
  isSelected: boolean;

  constructor(dataConnectorTypeIngest: DataConnectorTypeIngest, title: string, subtitle: string, icon: string) {
    this.title = title;
    this.subtitle = subtitle;
    this.icon = icon;
    this.dataConnectorTypeIngest = dataConnectorTypeIngest;
  }
}
export enum RowExclusionOperator {
  contains = 0,
  doesNotContain,
  isEqualTo,
  isNotEqualTo,
  greaterThan,
  greaterThanOrEqualTo,
  lessThan,
  lessThanOrEqualTo
}

export enum RowExclusionType {
  exclude = 0,
  include
}

export class RowExclusionOption {
  operator: RowExclusionOperator;
  columnName: string;
  value: string;
  groupId: string;
  exclusionType: RowExclusionType;

  constructor(columnName: string, operator: RowExclusionOperator, value: string, exclusionType: RowExclusionType) {
    this.columnName = columnName;
    this.operator = operator;
    this.value = value;
    this.exclusionType = exclusionType;
  }
}

export class UserDataImportInfo {
  lastUpdateDate?: Date;
  usersCount: number;
}

@Injectable({
  providedIn: 'root'
})
export class ConfigService {

  constructor(
    private httpClient: HttpClient,
    private environmentService: EnvironmentService
    ,private userData: UserDataService,
    private authService: AuthService  // Inject AuthService here
  ) { }

  async testDatabaseConnectorConnection(request: DatabaseConnectorTestConnectionRequest): Promise<DataConnectorTestConnectionResponse> {
    //console.log('testing database connection...');
    const body = JSON.stringify(request);
    //console.log('Sending body: ' + body);

    //const requestUrl = `${this.environmentService.activeAppBaseUrl}/api/Mapper/testDatabaseConnectorConnection`;
    const requestUrl = `${this.environmentService.activeEngineBaseUrl}/api/v1.0/engine/testSQLServerDbConnectorConnection`;
    const headers: HttpHeaders = new  HttpHeaders( {'content-type': 'application/json'});
    const result = this.httpClient.post<DataConnectorTestConnectionResponse>(requestUrl, body, { headers: headers}).toPromise();

    return result;
  }
  async sqlServerTableRowCount(request: DatabaseConnectorTestConnectionRequest): Promise<DataConnectorCountResponse> {
    //console.log('testing database connection...');
    const body = JSON.stringify(request);
    //console.log('Sending body: ' + body);
   
    const requestUrl = `${this.environmentService.activeEngineBaseUrl}/api/v1.0/engine/gettotalrowsSQLServer`;
    const headers: HttpHeaders = new  HttpHeaders( {'content-type': 'application/json'});
    const result = this.httpClient.post<DataConnectorCountResponse>(requestUrl, body, { headers: headers}).toPromise();
    return result;
  }
  async sqlServerMostRecentDate(request: DatabaseConnectorTestConnectionRequest): Promise<RecentAvailableDateResponse> {
    const body = JSON.stringify(request);
    const requestUrl = `${this.environmentService.activeEngineBaseUrl}/api/v1.0/engine/getMostRecentDateTimeSQLServer`;
    const headers: HttpHeaders = new  HttpHeaders( {'content-type': 'application/json'});
    const result = this.httpClient.post<RecentAvailableDateResponse>(requestUrl, body, { headers: headers}).toPromise();
    return result;
  }
  async mySQLMostRecentDate(request: MySqlDataConnectorTestConnectionRequest): Promise<RecentAvailableDateResponse> {
    const body = JSON.stringify(request);
    const requestUrl = `${this.environmentService.activeEngineBaseUrl}/api/v1.0/engine/getMostRecentDateTimeMySQL`;
    const headers: HttpHeaders = new  HttpHeaders( {'content-type': 'application/json'});
    const result = this.httpClient.post<RecentAvailableDateResponse>(requestUrl, body, { headers: headers}).toPromise();
    return result;
  }
  async verticaMostRecentDate(request: VerticaDataConnectorTestConnectionRequest): Promise<RecentAvailableDateResponse> {
    const body = JSON.stringify(request);
    const requestUrl = `${this.environmentService.activeEngineBaseUrl}/api/v1.0/engine/getMostRecentDateTimeVertica`;
    const headers: HttpHeaders = new  HttpHeaders( {'content-type': 'application/json'});
    const result = this.httpClient.post<RecentAvailableDateResponse>(requestUrl, body, { headers: headers}).toPromise();
    return result;
  }
  async oracleMostRecentDate(request: OracleDataConnectorTestConnectionRequest): Promise<RecentAvailableDateResponse> {
    const body = JSON.stringify(request);
    const requestUrl = `${this.environmentService.activeEngineBaseUrl}/api/v1.0/engine/getMostRecentDateTimeOracle`;
    const headers: HttpHeaders = new  HttpHeaders( {'content-type': 'application/json'});
    const result = this.httpClient.post<RecentAvailableDateResponse>(requestUrl, body, { headers: headers}).toPromise();
    return result;
  }
  async orcacleTableRowCount(request: OracleDataConnectorTestConnectionRequest): Promise<DataConnectorCountResponse> {
    const body = JSON.stringify(request);
    const requestUrl = `${this.environmentService.activeEngineBaseUrl}/api/v1.0/engine/gettotalrowsOracle`;
    const headers: HttpHeaders = new  HttpHeaders( {'content-type': 'application/json'});
    const result = this.httpClient.post<DataConnectorCountResponse>(requestUrl, body, { headers: headers}).toPromise();
    return result;
  }
  async mySQLTableRowCount(request: MySqlDataConnectorTestConnectionRequest): Promise<DataConnectorCountResponse> {
    const body = JSON.stringify(request);
    const requestUrl = `${this.environmentService.activeEngineBaseUrl}/api/v1.0/engine/gettotalrowsMySQL`;
    const headers: HttpHeaders = new  HttpHeaders( {'content-type': 'application/json'});
    const result = this.httpClient.post<DataConnectorCountResponse>(requestUrl, body, { headers: headers}).toPromise();
    return result;
  }
  async verticaTableRowCount(request: VerticaDataConnectorTestConnectionRequest): Promise<DataConnectorCountResponse> {
    const body = JSON.stringify(request);
    const requestUrl = `${this.environmentService.activeEngineBaseUrl}/api/v1.0/engine/gettotalrowsVertica`;
    const headers: HttpHeaders = new  HttpHeaders( {'content-type': 'application/json'});
    const result = this.httpClient.post<DataConnectorCountResponse>(requestUrl, body, { headers: headers}).toPromise();
    return result;
  }
  async testOracleConnectorConnection(request: OracleDataConnectorTestConnectionRequest): Promise<DataConnectorTestConnectionResponse> {
    const body = JSON.stringify(request);
    const requestUrl =  `${this.environmentService.activeEngineBaseUrl}/api/v1.0/engine/testOracleDbConnectorConnection`;
    const headers: HttpHeaders = new  HttpHeaders( {'content-type': 'application/json'});
    const result = this.httpClient.post<DataConnectorTestConnectionResponse>(requestUrl, body, { headers: headers}).toPromise();

    return result;
  }
  async testVerticaConnectorConnection(request: VerticaDataConnectorTestConnectionRequest): Promise<DataConnectorTestConnectionResponse> {
    const body = JSON.stringify(request);
    const requestUrl =  `${this.environmentService.activeEngineBaseUrl}/api/v1.0/engine/testVerticaDbConnectorConnection`;
    const headers: HttpHeaders = new  HttpHeaders( {'content-type': 'application/json'});
    const result = this.httpClient.post<DataConnectorTestConnectionResponse>(requestUrl, body, { headers: headers}).toPromise();

    return result;
  }
  async testMySqlConnectorConnection(request: MySqlDataConnectorTestConnectionRequest): Promise<DataConnectorTestConnectionResponse> {
    const body = JSON.stringify(request);
    const requestUrl =  `${this.environmentService.activeEngineBaseUrl}/api/v1.0/engine/testMySQLDbConnectorConnection`;
    const headers: HttpHeaders = new  HttpHeaders( {'content-type': 'application/json'});
    const result = this.httpClient.post<DataConnectorTestConnectionResponse>(requestUrl, body, { headers: headers}).toPromise();

    return result;
  }
  async getTableList(request: DatabaseConnectorTestConnectionRequest): Promise<DataConnectorTestConnectionResponse> {
    const body = JSON.stringify(request);
    const requestUrl = `${this.environmentService.activeEngineBaseUrl}/api/v1.0/engine/getSQLServerTableList`;
    const headers: HttpHeaders = new  HttpHeaders( {'content-type': 'application/json'});
    const result = this.httpClient.post<DataConnectorTestConnectionResponse>(requestUrl, body, { headers: headers}).toPromise();

    return result;
  }
  async getOracleTableList(request: OracleDataConnectorTestConnectionRequest): Promise<DataConnectorTestConnectionResponse> {
    const body = JSON.stringify(request);
    const requestUrl = `${this.environmentService.activeEngineBaseUrl}/api/v1.0/engine/getOracleTableList`;
    const headers: HttpHeaders = new  HttpHeaders( {'content-type': 'application/json'});
    const result = this.httpClient.post<DataConnectorTestConnectionResponse>(requestUrl, body, { headers: headers}).toPromise();

    return result;
  }
  async getVerticaTableList(request: VerticaDataConnectorTestConnectionRequest): Promise<DataConnectorTestConnectionResponse> {
    const body = JSON.stringify(request);
    const requestUrl = `${this.environmentService.activeEngineBaseUrl}/api/v1.0/engine/getVerticaTableList`;
    const headers: HttpHeaders = new  HttpHeaders( {'content-type': 'application/json'});
    const result = this.httpClient.post<DataConnectorTestConnectionResponse>(requestUrl, body, { headers: headers}).toPromise();

    return result;
  }
  async getMySqlTableList(request: MySqlDataConnectorTestConnectionRequest): Promise<DataConnectorTestConnectionResponse> {
    const body = JSON.stringify(request);
    const requestUrl = `${this.environmentService.activeEngineBaseUrl}/api/v1.0/engine/getMySQLTableList`;
    const headers: HttpHeaders = new  HttpHeaders( {'content-type': 'application/json'});
    const result = this.httpClient.post<DataConnectorTestConnectionResponse>(requestUrl, body, { headers: headers}).toPromise();

    return result;
  }
 
  async getDatetimeField(request: DatabaseConnectorTestConnectionRequest,tablename): Promise<DataConnectorTestConnectionResponse> {
    const body = JSON.stringify(request);
    const requestUrl = `${this.environmentService.activeEngineBaseUrl}/api/v1.0/engine/getSQLServerDatetimeFields`;
    const headers: HttpHeaders = new  HttpHeaders( {'content-type': 'application/json'});
    const result = this.httpClient.post<DataConnectorTestConnectionResponse>(requestUrl, body, { headers: headers}).toPromise();

    return result;
  }

  async getOracleDatetimeField(request: OracleDataConnectorTestConnectionRequest,tablename): Promise<DataConnectorTestConnectionResponse> {
    const body = JSON.stringify(request);
    const requestUrl = `${this.environmentService.activeEngineBaseUrl}/api/v1.0/engine/getOracleDatetimeFields`;
    const headers: HttpHeaders = new  HttpHeaders( {'content-type': 'application/json'});
    const result = this.httpClient.post<DataConnectorTestConnectionResponse>(requestUrl, body, { headers: headers}).toPromise();

    return result;
  }
  async getVerticaDatetimeField(request: VerticaDataConnectorTestConnectionRequest,tablename): Promise<DataConnectorTestConnectionResponse> {
    const body = JSON.stringify(request);
    const requestUrl = `${this.environmentService.activeEngineBaseUrl}/api/v1.0/engine/getVerticaDatetimeFields`;
    const headers: HttpHeaders = new  HttpHeaders( {'content-type': 'application/json'});
    const result = this.httpClient.post<DataConnectorTestConnectionResponse>(requestUrl, body, { headers: headers}).toPromise();

    return result;
  }
  async getMySqlDatetimeField(request: MySqlDataConnectorTestConnectionRequest,tablename): Promise<DataConnectorTestConnectionResponse> {
    const body = JSON.stringify(request);
    const requestUrl = `${this.environmentService.activeEngineBaseUrl}/api/v1.0/engine/getMySQLDatetimeFields`;
    const headers: HttpHeaders = new  HttpHeaders( {'content-type': 'application/json'});
    const result = this.httpClient.post<DataConnectorTestConnectionResponse>(requestUrl, body, { headers: headers}).toPromise();

    return result;
  }
  async runConfig<TResponse>(request: RunConfigRequest): Promise<TResponse> {
    const body = JSON.stringify(request);
    const requestUrl = `${this.environmentService.activeEngineBaseUrl}/api/v1.0/engine/runConfig`;
    const headers: HttpHeaders = new  HttpHeaders( {'content-type': 'application/json'});
    const result = this.httpClient.post<TResponse>(requestUrl, body, { headers}).toPromise();
    return result;
  }
  /** Phase 2, docs/Node_Input_Resolution_Architecture.md: read-only -- resolves
   * where a transformer's input lives, derived server-side from the saved
   * pipeline config. Replaces GetCacheKeyRequest()'s own client-side
   * `selectedTrans.index === 1` decision for PreviewType.transInput, which is
   * what the original T1-reorder bug this whole redesign started from actually
   * came from. */
  async resolveTransformerInput(refineryId: string, nodeId: string, transformId: string):
      Promise<{ cacheKeyType: number; nodeId: string; transformId: string }> {
    const body = JSON.stringify({ refineryId, nodeId, transformId });
    const requestUrl = `${this.environmentService.activeEngineBaseUrl}/api/v1.0/engine/resolveTransformerInput`;
    const headers: HttpHeaders = new HttpHeaders({ 'content-type': 'application/json' });
    return this.httpClient.post<{ cacheKeyType: number; nodeId: string; transformId: string }>(
      requestUrl, body, { headers }).toPromise();
  }
  /** "Audit Compiler Quality" -- runs the general and compiled engines against the
   * same real, currently-cached input farm and reports whether they agree. See
   * app/compiled/compiler_audit.py's own docstring for the full design. Always
   * forces the full farm server-side, regardless of the page's current sample
   * settings -- this must test what the compiled path actually runs in production. */
  async auditCompiler<TResponse>(transformType: number, config: any, inputCacheKey: string, configGuid: string, transformGuid: string, orgId?: string, userId?: string, refineryId?: string): Promise<TResponse> {
    const body = JSON.stringify({ transformType, config, inputCacheKey, configGuid, transformGuid, orgId, userId, refineryId });
    const requestUrl = `${this.environmentService.activeEngineBaseUrl}/api/v1.0/compiled/audit`;
    const headers: HttpHeaders = new HttpHeaders({ 'content-type': 'application/json' });
    const result = this.httpClient.post<TResponse>(requestUrl, body, { headers }).toPromise();
    return result;
  }
  async runCurrentConfig<TResponse>(request: RunCurrentConfigRequest): Promise<TResponse> {
    const body = JSON.stringify(request);
    const requestUrl = `${this.environmentService.activeEngineBaseUrl}/api/v1.0/engine/runcurrenttransformer`;
    const headers: HttpHeaders = new  HttpHeaders( {'content-type': 'application/json'});
    const result = this.httpClient.post<TResponse>(requestUrl, body, { headers}).toPromise();
    return result;
  }
  /** The pre-run check (Flask /engine/checktransformer): the Transformer error analysis run on
   * the config being edited. Returns {errors, warnings}; never blocks on its own failure. */
  async checkTransformer(request: any): Promise<any> {
    const requestUrl = `${this.environmentService.activeEngineBaseUrl}/api/v1.0/engine/checktransformer`;
    const headers: HttpHeaders = new HttpHeaders({'content-type': 'application/json'});
    return this.httpClient.post<any>(requestUrl, JSON.stringify(request), { headers }).toPromise();
  }

  async runCurrentConfigUrl(): Promise<string> {
    return `${this.environmentService.activeEngineBaseUrl}/api/v1.0/engine/runcurrenttransformer`;
  }
  async saveProcessorNode(request: JSON): Promise<string> {
    const body = JSON.stringify(request);
    const requestUrl = `${this.environmentService.activeEngineBaseUrl}/api/v1.0/engine/saveProcessorNode`;
    const headers: HttpHeaders = new  HttpHeaders( {'content-type': 'application/json'});
    const result = this.httpClient.post<string>(requestUrl, body, { headers}).toPromise();

    return result;
  }

  async getInputDataForNode(request: GetDataFarmPreviewRequest): Promise<GetDataFarmPreviewResponse> {
    const body = JSON.stringify(request);
    const requestUrl = `${this.environmentService.activeEngineBaseUrl}/api/v1.0/engine/readInputofProcessorNode`;
    const headers: HttpHeaders = new  HttpHeaders( {'content-type': 'application/json'});
    const result = this.httpClient.post<GetDataFarmPreviewResponse>(requestUrl, body, { headers}).toPromise();

    return result;
  }

  async importData(request: PreviewDataImportRequest): Promise<ImportDataResponse> {
    const body = JSON.stringify(request);
    const requestUrl = `${this.environmentService.activeEngineBaseUrl}/api/v1.0/importData`;
    const headers: HttpHeaders = new  HttpHeaders( {'content-type': 'application/json'});
    const result = this.httpClient.post<ImportDataResponse>(requestUrl, body, { headers}).toPromise();

    return result;
  }

  async saevIngestFileData(request: DataTransformerConfig): Promise<string> {
    const body = JSON.stringify(request);
    const requestUrl = `${this.environmentService.activeEngineBaseUrl}/api/v1.0/engine/saveIngestData`;
    const headers: HttpHeaders = new  HttpHeaders( {'content-type': 'application/json'});
    const result = this.httpClient.post<string>(requestUrl, body, { headers}).toPromise();

    return result;
  }
  async saevIngestFileDataUrl(): Promise<string> {
    return `${this.environmentService.activeEngineBaseUrl}/api/v1.0/engine/saveIngestData`;
  }
  
  async getDataFarmPreviewAsync(request: GetDataFarmPreviewRequest): Promise<GetDataFarmPreviewResponse> {
    const body = JSON.stringify(request);
    const requestUrl = `${this.environmentService.activeEngineBaseUrl}/api/v1.0/engine/getDataFarmPreview`;
    const headers: HttpHeaders = new  HttpHeaders( {'content-type': 'application/json'});
    const result = this.httpClient.post<GetDataFarmPreviewResponse>(requestUrl, body, { headers}).toPromise();

    return result;
  }

  // Fetch Raw Data For Preview
  async getRawDataFarmPreviewAsync(request: GetDataFarmPreviewIngestRequest): Promise<GetDataFarmPreviewResponse> {
    //console.log(`Getting preview data for dataFarm + ${request.dataFarmId}...`);
    const body = JSON.stringify(request);
    //console.log('Sending body: ' + body);

    const requestUrl = `${this.environmentService.activeEngineBaseUrl}/api/v1.0/engine/getRawDataFarmPreview`;
    const headers: HttpHeaders = new  HttpHeaders( {'content-type': 'application/json'});
    const result = this.httpClient.post<GetDataFarmPreviewResponse>(requestUrl, body, { headers}).toPromise();

    return result;
  }
  // Fetch Raw Data For Preview
  async getInputDataFarmPreviewAsync(request: GetDataFarmPreviewIngestRequest): Promise<GetDataFarmPreviewResponse> {
    //console.log(`Getting preview data for dataFarm + ${request.dataFarmId}...`);
    const body = JSON.stringify(request);
    //console.log('Sending body: ' + body);

    const requestUrl = `${this.environmentService.activeEngineBaseUrl}/api/v1.0/engine/getInputDataFarmPreview`;
    const headers: HttpHeaders = new  HttpHeaders( {'content-type': 'application/json'});
    const result = this.httpClient.post<GetDataFarmPreviewResponse>(requestUrl, body, { headers}).toPromise();

    return result;
  }

  // Fetch Output Data for Preview
  async getOutputDataFarmPreviewAsync(request: GetDataFarmPreviewRequest): Promise<GetDataFarmPreviewResponse> {
    const body = JSON.stringify(request);
    //console.log('Sending body: ' + body);

    const requestUrl = `${this.environmentService.activeEngineBaseUrl}/api/v1.0/engine/getOutputDataFarmPreview`;
    const headers: HttpHeaders = new  HttpHeaders( {'content-type': 'application/json'});
    const result = this.httpClient.post<GetDataFarmPreviewResponse>(requestUrl, body, { headers}).toPromise();

    return result;
  }

  async getFilteredvalsselectdcolAsync(request: GetFilteredselcolvalsRequest): Promise<GetFilteredselcolvalsResponse> {
    const body = JSON.stringify(request);
    const requestUrl = `${this.environmentService.activeEngineBaseUrl}/api/v1.0/engine/getFilterdataSelectedColumn`;
    const headers: HttpHeaders = new  HttpHeaders( {'content-type': 'application/json'});
    const result = this.httpClient.post<GetFilteredselcolvalsResponse>(requestUrl, body, { headers}).toPromise();

    return result;
  }

  async getConfigByGuidAsync(configGuid: string): Promise<DataTransformerConfig> {
    //console.log(`Getting config : ${configGuid}`);

    const requestUrl = `${this.environmentService.activeAppBaseUrl}/api/Config/${configGuid}`;
    const headers: HttpHeaders = new  HttpHeaders( {'content-type': 'application/json'});
    const result = await this.httpClient.get<string>(requestUrl, { headers}).toPromise();
    //console.log(result);
    const config: DataTransformerConfig = DataTransformerConfig.fromJSON(result);

    return config;
  }

  async getConfigAsync(configId: number): Promise<DataTransformerConfig> {
    //console.log(`Getting config : ${configId}`);

    const requestUrl = `${this.environmentService.activeAppBaseUrl}/api/Config/${configId}`;
    const headers: HttpHeaders = new  HttpHeaders( {'content-type': 'application/json'});
    const result = this.httpClient.get<DataTransformerConfig>(requestUrl, { headers}).toPromise();

    return result;
  }

  async deleteConfigByGuid(guid: string): Promise<boolean> {
    //console.log(`Deleting config : ${guid}`);

    const requestUrl = `${this.environmentService.activeAppBaseUrl}/api/Config/${guid}`;
    const headers: HttpHeaders = new  HttpHeaders( {'content-type': 'application/json'});
    const result = this.httpClient.delete<boolean>(requestUrl, { headers}).toPromise();

    return result;
  }

  async deleteConfigById(configId: number): Promise<boolean> {
    //console.log(`Deleting config : ${configId}`);

    const requestUrl = `${this.environmentService.activeAppBaseUrl}/api/Config/${configId}`;
    const headers: HttpHeaders = new  HttpHeaders( {'content-type': 'application/json'});
    const result = this.httpClient.delete<boolean>(requestUrl, { headers}).toPromise();

    return result;
  }

  async deleteTransform(transformId: number): Promise<boolean> {
    //console.log(`Deleting transform : ${transformId}`);

    const requestUrl = `${this.environmentService.activeAppBaseUrl}/api/Config/transform/${transformId}`;
    const headers: HttpHeaders = new  HttpHeaders( {'content-type': 'application/json'});
    const result = this.httpClient.delete<boolean>(requestUrl, { headers}).toPromise();

    return result;
  }

  // async browseFilesAsync(browseFolderRequest: BrowseFolderRequest): Promise<BrowseFolderResponse> {
  //   const body = JSON.stringify(browseFolderRequest);
  //   const requestUrl = `${this.environmentService.activeEngineBaseUrl}/api/v1.0/browseFolder`;
  //   const headers: HttpHeaders = new  HttpHeaders( {'content-type': 'application/json'});
  //   const result = this.httpClient.post<BrowseFolderResponse>(requestUrl, body, { headers}).toPromise();
  //   //console.log('result: ' +JSON.stringify(result));
  //   return result;
  // }

  async browseFilesAsyncNew(browseFolderRequest: BrowseFolderRequest): Promise<BrowseFolderResponse> {
    const body = JSON.stringify(browseFolderRequest);
    const requestUrl = `${this.environmentService.activeEngineBaseUrl}/api/v1.0/browseFolder_new`;
    const headers: HttpHeaders = new  HttpHeaders( {'content-type': 'application/json'});
    const result = this.httpClient.post<BrowseFolderResponse>(requestUrl, body, { headers}).toPromise();
    //console.log('result: ' +JSON.stringify(result));
    return result;
  }

  async browseFoldersAsync(organizationId: number): Promise<BrowseFolderResponse> {
    const body = JSON.stringify( new BrowseFolderSelectRequest(organizationId));
    //console.log('Sending body: ' + body);

    const requestUrl = `${this.environmentService.activeEngineBaseUrl}/api/v1.0/dataWriterFileSavePath`;
    //console.log('requestUrl: ' + requestUrl);
    const headers: HttpHeaders = new  HttpHeaders( {'content-type': 'application/json'});
    
    const result1 = this.httpClient.post(requestUrl, body, { headers});
    //console.log('result1: ' +result1);
    const result = this.httpClient.post<BrowseFolderResponse>(requestUrl, body, { headers}).toPromise();
    //console.log('result: ' +JSON.stringify(result));
    return result;
  }

  async browseParquetPartitionFoldersAsync(organizationId: number, parquetPartitionFolderPath: string): Promise<BrowseFolderResponse> {
    const body = JSON.stringify( new BrowseParquetPartitionFolderRequest(organizationId, parquetPartitionFolderPath));
    //console.log('Sending body: ' + body);

    const requestUrl = `${this.environmentService.activeEngineBaseUrl}/api/v1.0/browseparquetPartitionSubfolders`;
    //console.log('requestUrl: ' + requestUrl);
    const headers: HttpHeaders = new  HttpHeaders( {'content-type': 'application/json'});
    
    const result1 = this.httpClient.post(requestUrl, body, { headers});
    //console.log('result1: ' +result1);
    const result = this.httpClient.post<BrowseFolderResponse>(requestUrl, body, { headers}).toPromise();
    //console.log('result: ' +JSON.stringify(result));
    return result;
  }

  async getExcelSheetNames(getExcelSheetNamesRequest: GetExcelSheetNamesRequest): Promise<Array<string>> {
    //console.log('Getting sheetnames for file ' + path);
    const body = JSON.stringify(getExcelSheetNamesRequest);
    //console.log('Sending body: ' + body);
    
    const requestUrl = `${this.environmentService.activeEngineBaseUrl}/api/v1.0/engine/getExcelSheetList`;
    const headers: HttpHeaders = new  HttpHeaders( {'content-type': 'application/json'});
    const result = this.httpClient.post<Array<string>>(requestUrl, body, { headers}).toPromise();

    return result;
  }
  
  async getFeatherFileExistCheck(path: string): Promise<FileExistCheckResponse> {
    const body = JSON.stringify(new GetFeatherFileRequest(path));
  
    const requestUrl = `${this.environmentService.activeEngineBaseUrl}/api/v1.0/engine/isFTRFileexistsOrNot`;
    const headers: HttpHeaders = new HttpHeaders({ 'content-type': 'application/json' });
  
    const result = await this.httpClient.post<FileExistCheckResponse>(requestUrl, body, { headers }).toPromise();
    
    return result;
  }
    async getParquetFileExistCheck(path: string): Promise<FileExistCheckResponse> {
    const body = JSON.stringify(new GetParquetFileRequest(path));
  
    const requestUrl = `${this.environmentService.activeEngineBaseUrl}/api/v1.0/engine/isFTRFileexistsOrNot`;
    const headers: HttpHeaders = new HttpHeaders({ 'content-type': 'application/json' });
  
    const result = await this.httpClient.post<FileExistCheckResponse>(requestUrl, body, { headers }).toPromise();
    
    return result;
  }
  async getAllConfigs(organizationId: number): Promise<DataTransformerConfig[]> {
    //console.log('Getting configs for organization ' + organizationId);

    const requestUrl = `${this.environmentService.activeAppBaseUrl}/api/Config/configs/${organizationId}`;
    const headers: HttpHeaders = new  HttpHeaders( {'content-type': 'application/json'});
    //const result = this.httpClient.get<DataTransformerConfig[]>(requestUrl, { headers}).toPromise();
    const result = await this.httpClient.get<string[]>(requestUrl, { headers}).toPromise();
    const configs = new Array<DataTransformerConfig>();
    result.forEach( json => {
        try {
          const config: DataTransformerConfig = DataTransformerConfig.fromJSON(JSON.parse(json));
          configs.push(config);
        } catch (err) {
          // //console.log('Failed to deserialize config json: ' + json);
        }
      }
    );
    //console.log('Received configs!');
    //console.log(configs);

    return configs;

    //return result;
  }
  async getRefineryAllConfigs(configGuids: string[]): Promise<DataTransformerConfig[]> {
    const requestUrl = `${this.environmentService.activeAppBaseUrl}/api/Config/getRefinerAllConfig`;
    const headers: HttpHeaders = new  HttpHeaders( {'content-type': 'application/json'});
    const body = JSON.stringify(configGuids);
    const result = await this.httpClient.post<string[]>(requestUrl, body,{ headers}).toPromise();
    const configs: DataTransformerConfig[] = [];
    result?.forEach( json => {
        try {
          const config = DataTransformerConfig.fromJSON(JSON.parse(json));
          configs.push(config);
        } catch (err) {
          console.warn("Failed to parse config:", err);
        }
      }
    );

    return configs;
  }

  async getLastUserDataImportInfo(organizationId: number): Promise<UserDataImportInfo> {
    //console.log('Getting userdata import info...');

    const requestUrl = `${this.environmentService.activeAppBaseUrl}/api/Mapper/userData/info/${organizationId}`;
    const headers: HttpHeaders = new  HttpHeaders( {'content-type': 'application/json'});
    const result = this.httpClient.get<UserDataImportInfo>(requestUrl, { headers}).toPromise();

    return result;
  }

  async upsertConfigJson(config: DataTransformerConfig): Promise<string> {
    //console.log('Saving new data transform config...');

    const requestUrl = `${this.environmentService.activeAppBaseUrl}/api/Config/upsertConfigJson`;
    const headers: HttpHeaders = new  HttpHeaders( {'content-type': 'application/json'});

    const body = JSON.stringify(JSON.stringify(config));
    //console.log('Sending body: ' + body);

    const result = this.httpClient.post<string>(requestUrl, body, { headers}).toPromise();
    
    return result;
  }

  async upsertConfig(config: DataTransformerConfig): Promise<DataTransformerConfig> {
    //console.log('Saving new data transform config...');
    //to avoid errors due to data type change in general parameter in ingest. can delete the code after
    config.generalParameter.integerDefVal=config.generalParameter.integerDefVal.toString();
    config.generalParameter.floatDefVal=config.generalParameter.floatDefVal.toString();
    config.generalParameter.durationDefVal=config.generalParameter.durationDefVal.toString();


    const requestUrl = `${this.environmentService.activeAppBaseUrl}/api/Config/upsertConfig`;
    const headers: HttpHeaders = new  HttpHeaders( {'content-type': 'application/json'});

    const body = JSON.stringify(config);
    //console.log('Sending body: ' + body);

    const result = await this.httpClient.post(requestUrl, body, { headers}).toPromise();
    const updatedConfig = DataTransformerConfig.fromJSON(result);
    if (updatedConfig instanceof DataTransformerConfig) {
      const i = 0;
    }
    //const updatedConfig: DataTransformerConfig = DataTransformerConfig.fromJSON(JSON.parse(updatedConfig));
    this.userData.setSelectedConfigJson(updatedConfig);
    return updatedConfig;
  }

  async loadColumns(request: GetColumnsRequest): Promise<ColumnDefinition[]> {

    const body = JSON.stringify( request );
    //console.log('Sending body - loadColumns: ' + body);

    const requestUrl = `${this.environmentService.activeEngineBaseUrl}/api/v1.0/engine/getColumns`;
    const headers: HttpHeaders = new  HttpHeaders( {'content-type': 'application/json'});
    const result = this.httpClient.post<ColumnDefinition[]>(requestUrl, body, { headers}).toPromise();

    return result;
  }

  async loadColumnsV2(request: GetColumnsRequest): Promise<ColumnDefinition[]> {

    const body = JSON.stringify( request );
    //console.log('Sending body - loadColumns: ' + body);

    const requestUrl = `${this.environmentService.activeEngineBaseUrl}/api/v1.0/engine/getColumnsV2`;
    const headers: HttpHeaders = new  HttpHeaders( {'content-type': 'application/json'});
    const result = this.httpClient.post<ColumnDefinition[]>(requestUrl, body, { headers}).toPromise();

    return result;
  }

  async createMasterColMappings(request: CreateMasterColMappingsRequest): Promise<CreateMasterColMappingsResponse> {

    const body = JSON.stringify( request );
    //console.log('Sending body - loadColumns: ' + body);

    const requestUrl = `${this.environmentService.activeEngineBaseUrl}/api/v1.0/engine/createMasterColumnMappings`;
    const headers: HttpHeaders = new  HttpHeaders( {'content-type': 'application/json'});
    const result = this.httpClient.post<CreateMasterColMappingsResponse>(requestUrl, body, { headers}).toPromise();

    return result;
  }
  
  async getUnifiedColumnMappingsMapLibrary(request: GetUnifiedColmappingMapLibRequest): Promise<GetUnifiedColmappingMapLibResponse> {

    const body = JSON.stringify( request );
    //console.log('Sending body - loadColumns: ' + body);

    const requestUrl = `${this.environmentService.activeEngineBaseUrl}/api/v1.0/engine/getUnifiedColumnMappingsMapLibrary`;
    const headers: HttpHeaders = new  HttpHeaders( {'content-type': 'application/json'});
    const result = this.httpClient.post<GetUnifiedColmappingMapLibResponse>(requestUrl, body, { headers}).toPromise();

    return result;
  }

  async detectDelimiterAsync(detectDelimiterRequest: DetectDelimiterRequest): Promise<DetectDelimiterResponse> {
    const body = JSON.stringify(detectDelimiterRequest);
    //console.log('Sending body: ' + body);
    //console.log(`endPoint: ${this.environmentService.activeEngineBaseUrl}`);

    const requestUrl = `${this.environmentService.activeEngineBaseUrl}/api/v1.0/detectDelimiter`;
    const headers: HttpHeaders = new  HttpHeaders( {'content-type': 'application/json'});
    const result = this.httpClient.post<DetectDelimiterResponse>(requestUrl, body, { headers}).toPromise();

    return result;
  }
  
  getFileList(): Observable<FileNode[]> {
    return this.httpClient.get<FileNode[]>('/assets/fileList.json');
  }
  // Fields on link.data present on every persisted DataRefineryConfig that are always
  // fully rebuilt from scratch by positioningNodes() the moment the config is next loaded
  // (loadConfigDetail() calls it unconditionally before anything renders) — nothing reads
  // them back out of a freshly-loaded config before they're overwritten, so sending them to
  // the server is pure wasted payload/storage, not a value anything downstream depends on.
  // Kept OUT of the live in-memory config (this only builds a stripped COPY for the request
  // body) — the app keeps using the full, already-computed object after save completes.
  private static readonly TRANSIENT_LINK_DATA_FIELDS: string[] = [
    'sourcelinkcount', 'targetlinkcount',
    'sourcetotup', 'sourcetotdown', 'targettotup', 'targettotdown',
    'sourcepositionnumber', 'targetpositionnumber',
    'totallinestart', 'totallineend',
    'node_x_gap_start',
    'sourceweight', 'targetweight',
    'sourcerowdist', 'targetrowdist',
  ];

  private stripTransientFieldsForSave(config: DataRefineryConfig): any {
    const strippedNodes = (config.nodes ?? []).map((n: any) => {
      const { position, dimension, ...rest } = n;
      return rest;
    });
    const strippedLinks = (config.links ?? []).map((l: any) => {
      const data = { ...l.data };
      for (const field of ConfigService.TRANSIENT_LINK_DATA_FIELDS) {
        delete data[field];
      }
      return { ...l, data };
    });
    return { ...config, nodes: strippedNodes, links: strippedLinks };
  }

  async UpsertRefineryConfig(config: DataRefineryConfig): Promise<DataRefineryConfig> {
    //console.log('Saving new data Refinery config...');

    const requestUrl = `${this.environmentService.activeAppBaseUrl}/api/Config/upsertRefineryConfig`;
    const headers: HttpHeaders = new  HttpHeaders( {'content-type': 'application/json'});

    const body = JSON.stringify(this.stripTransientFieldsForSave(config));
    //console.log('Sending body Save Refinery: ' + body);

    let result: any;
    try {
      result = await this.httpClient.post(requestUrl, body, { headers}).toPromise();
    } catch (err) {
      // 409 = the server rejected this save because the refinery changed since
      // this client loaded it (optimistic-concurrency check) — surface that
      // distinctly so callers can tell "someone else saved first" apart from
      // any other failure, instead of both silently overwriting or looking
      // like the same generic error.
      if (err instanceof HttpErrorResponse && err.status === 409) {
        const conflict = err.error;
        throw new RefineryConflictError(
          conflict?.message ?? 'This refinery was changed by someone else since you loaded it. Reload the refinery and try again.',
          conflict?.yourRevision,
          conflict?.currentRevision
        );
      }
      throw err;
    }
    const updatedConfig = DataRefineryConfig.fromJSON(result);
    if (updatedConfig instanceof DataRefineryConfig) {
      const i = 0;
    }
    // Advance the CALLER'S object in place — not just the returned copy — so
    // every existing call site stays correctly in sync with the new revision
    // even if it discards the return value (several do). Without this, a
    // caller's next save would still be holding the pre-save revision and
    // would spuriously conflict with its own prior save.
    config.revision = updatedConfig.revision;
    config.guid = updatedConfig.guid;
    this.userData.setSelectedRefineryDetails(updatedConfig);
    return updatedConfig;
  }

  // Refinery presence ("is someone else in here right now") HTTP calls now
  // live entirely in RefineryPresenceService — not here — specifically to
  // avoid a circular DI dependency: AuthService needs to release presence on
  // logout, and ConfigService already (independently) depends on AuthService
  // for user details, so anything in ConfigService that AuthService also
  // needs creates a cycle. Colocating all presence calls in their own
  // service also just fits single-responsibility better than bolting them
  // onto the generic config CRUD service.

  //save refinery into database table
  async UpsertRefineryTable(config: TableRefinery): Promise<void> {
    const requestUrl = `${this.environmentService.activeAppBaseUrl}/api/Account/insertrefinery`;
    const headers = new HttpHeaders({'Content-Type': 'application/json'});
    const body = JSON.stringify(config);
    try {
      // Send POST request to insert/update the refinery details
      const result = await this.httpClient.post(requestUrl, body, { headers }).toPromise();
  
    } catch (error) {
      console.error('Error saving refinery data:', error);
      throw error;
    }
  }
  
  // UPdate the upcoming Nodes Status
  async updateUpcomingNodesStatus(updateNodesStatusRequest: UpdateNodesStatusRequest): Promise<RunrefineryResponse> {
    const requestUrl = `${this.environmentService.activeEngineBaseUrl}/api/v1.0/engine/updateforwardnodestatus`;
    const headers: HttpHeaders = new  HttpHeaders( {'content-type': 'application/json'});

    const body = JSON.stringify(updateNodesStatusRequest);
    //console.log('Reset Refinery Send Param: ' + body);

    const result = await this.httpClient.post<RunrefineryResponse>(requestUrl, body, { headers}).toPromise();
    return result;
  }

  //RESET REFINERY V1.0
  async resetRefinery(runRefineryRequest: RunrefineryRequest): Promise<RunrefineryResponse> {
    const requestUrl = `${this.environmentService.activeEngineBaseUrl}/api/v1.0/refinery/reset`;
    const headers: HttpHeaders = new  HttpHeaders( {'content-type': 'application/json'});

    const body = JSON.stringify(runRefineryRequest);
    //console.log('Reset Refinery Send Param: ' + body);

    const result = await this.httpClient.post<RunrefineryResponse>(requestUrl, body, { headers}).toPromise();
    return result;
  }
  //RESET NODE REFINERY V1.0
  async resetNodeRefinery(runNodeRequest: RunrefineryRequest): Promise<RunrefineryResponse> {
    const requestUrl = `${this.environmentService.activeEngineBaseUrl}/api/v1.0/refinery/resetnode`;
    const headers: HttpHeaders = new  HttpHeaders( {'content-type': 'application/json'});

    const body = JSON.stringify(runNodeRequest);
    //console.log('Reset Refinery Send Param: ' + body);

    const result = await this.httpClient.post<RunrefineryResponse>(requestUrl, body, { headers}).toPromise();
    return result;
  }
  //RUN REFINERY V1.0
  async runRefinery(runRefineryRequest: RunrefineryRequest): Promise<RunrefineryResponse> {
    const requestUrl = `${this.environmentService.activeEngineBaseUrl}/api/v1.0/refinery/run`;
    const headers: HttpHeaders = new  HttpHeaders( {'content-type': 'application/json'});

    const body = JSON.stringify(runRefineryRequest);
    //console.log('Run Refinery: ' + body);

    const result = await this.httpClient.post<RunrefineryResponse>(requestUrl, body, { headers}).toPromise();
    return result;
  }
  //RESET NODE REFINERY V1.0
  async resetTransformer(resetTransformerRequest: ResetTransformerRequest): Promise<ResetTransformerResponse> {
    const requestUrl = `${this.environmentService.activeEngineBaseUrl}/api/v1.0/engine/resetTransformerCache`;
    const headers: HttpHeaders = new  HttpHeaders( {'content-type': 'application/json'});

    const body = JSON.stringify(resetTransformerRequest);
    //console.log('Reset Refinery Send Param: ' + body);

    const result = await this.httpClient.post<ResetTransformerResponse>(requestUrl, body, { headers}).toPromise();
    return result;
  }
  async runRefineryRequestUrl(): Promise<string> {
    return `${this.environmentService.activeEngineBaseUrl}/api/v1.0/refinery/run`;
  }

  //RUN ONE NODE of REFINERY V1.0
  async runRefineryNode(runNodeRequest: RunrefineryRequest): Promise<RunrefineryResponse> {
    const requestUrl = `${this.environmentService.activeEngineBaseUrl}/api/v1.0/refinery/runnode`;
    const headers: HttpHeaders = new  HttpHeaders( {'content-type': 'application/json'});

    const body = JSON.stringify(runNodeRequest);
    //console.log('Run Node: ' + body);

    const result = await this.httpClient.post<RunrefineryResponse>(requestUrl, body, { headers}).toPromise();
    return result;
  }
  async runRefineryNodeRequestUrl(): Promise<string> {
    return `${this.environmentService.activeEngineBaseUrl}/api/v1.0/refinery/runnode`;
  }

    //READ SELECTED REFINERY FILE CONTENTS
    async readSelectdRefineryFile(readRefineryRequest: ReadRefineryRequest): Promise<ReadRefineryResponse> {
      const requestUrl = `${this.environmentService.activeEngineBaseUrl}/api/v1.0/refinery/readRefineryFile`;
      const headers: HttpHeaders = new  HttpHeaders( {'content-type': 'application/json'});
  
      const body = JSON.stringify(readRefineryRequest);
      //console.log('Run Refinery: ' + body);
  
      const result = await this.httpClient.post<ReadRefineryResponse>(requestUrl, body, { headers}).toPromise();
      return result;
    }

  // EXPORT a refinery as a portable, encrypted .dtr package — hits the .NET
  // DataTransformerAPI (activeAppBaseUrl), not the Python engine; the server
  // encrypts the underlying ZIP (RefineryExportService/PackageEncryptionService)
  // before it ever reaches the browser. The download's filename comes back from
  // the server's Content-Disposition header (RefineryName_yyyyMMdd_HHmmss.dtr)
  // so the browser save keeps the same name the API generated.
  async exportRefinery(refineryGuid: string): Promise<{ blob: Blob, fileName: string }> {
    const requestUrl = `${this.environmentService.activeAppBaseUrl}/api/Refineries/${refineryGuid}/export`;

    const response = await this.httpClient.post(requestUrl, null, {
      observe: 'response',
      responseType: 'blob'
    }).toPromise();

    let fileName = `${refineryGuid}.dtr`;
    const contentDisposition = response.headers.get('content-disposition');
    if (contentDisposition) {
      const match = /filename="?([^";]+)"?/i.exec(contentDisposition);
      if (match) {
        fileName = match[1];
      }
    }

    return { blob: response.body as Blob, fileName };
  }

  // IMPORT a refinery from an exported .dtr package (or a legacy .zip export).
  // Uploaded as multipart/form-data — deliberately no explicit content-type header
  // (unlike every JSON call in this file) so the browser sets the multipart
  // boundary itself.
  async importRefinery(file: File): Promise<ImportRefineryResponse> {
    const requestUrl = `${this.environmentService.activeAppBaseUrl}/api/Refineries/import`;

    const formData = new FormData();
    formData.append('file', file, file.name);

    try {
      const result: any = await this.httpClient.post(requestUrl, formData).toPromise();
      return new ImportRefineryResponse(result.refineryGuid, result.refineryName, result.revision, result.warnings);
    } catch (err) {
      // 409 = duplicate-filename guard tripped; 400 = package failed structural
      // validation. Both carry a Analyst-facing message straight from the server —
      // surface it verbatim rather than a generic one, same as RefineryConflictError.
      if (err instanceof HttpErrorResponse && (err.status === 409 || err.status === 400)) {
        throw new ImportRefineryError(err.error?.message ?? 'Failed to import the refinery package.', err.error?.conflictingFileNames);
      }
      throw err;
    }
  }

  // Ingest File Management — the ingest folder (System.ingestPath / IEnvService
  // .IngestBasePath) is one shared folder today, not per-organization, so these
  // three calls need no organizationId. All three live on activeAppBaseUrl
  // (.NET), not activeEngineBaseUrl (Python) like the existing browseFolder_new/
  // dataWriterFileSavePath dialogs — this is a deliberate divergence: unlike
  // those read-only browse dialogs, upload/delete are security-sensitive and
  // .NET is the only backend with session auth today.
  async getIngestTreeAsync(): Promise<IngestTreeNode> {
    const requestUrl = `${this.environmentService.activeAppBaseUrl}/api/IngestFiles/tree`;
    return this.httpClient.get<IngestTreeNode>(requestUrl).toPromise();
  }

  async getIngestUploadLimitsAsync(): Promise<IngestUploadLimits> {
    const requestUrl = `${this.environmentService.activeAppBaseUrl}/api/IngestFiles/uploadLimits`;
    return this.httpClient.get<IngestUploadLimits>(requestUrl).toPromise();
  }

  // Returns the raw event stream (not just the final result) so the caller can
  // observe HttpEventType.UploadProgress for a real, per-file progress percentage
  // — one file per call, so N concurrently-selected files become N independent
  // subscriptions and one failing never blocks or hides the others.
  uploadIngestFile(file: File): Observable<HttpEvent<IngestUploadResult>> {
    const requestUrl = `${this.environmentService.activeAppBaseUrl}/api/IngestFiles/upload`;
    const formData = new FormData();
    formData.append('file', file, file.name);
    return this.httpClient.post<IngestUploadResult>(requestUrl, formData, {
      reportProgress: true,
      observe: 'events'
    });
  }

  async deleteIngestFileAsync(relativePath: string): Promise<boolean> {
    const requestUrl = `${this.environmentService.activeAppBaseUrl}/api/IngestFiles/file?relativePath=${encodeURIComponent(relativePath)}`;
    const result: any = await this.httpClient.delete(requestUrl).toPromise();
    return !!result?.status;
  }

  async getAllRefineryConfigs(): Promise<DataRefineryConfig[]> {

    const user = this.authService.getUserDetails();  // Fetch the user details
    const username = user?.userName;  // Assuming 'username' is a property of the user details object
   // const requestUrl = `${this.environmentService.activeAppBaseUrl}/api/Config/refineryConfigs`;
   var organizationId=this.userData.getSelectedOrganization();
    const requestUrl = `${this.environmentService.activeAppBaseUrl}/api/Config/refineryConfigs?username=${encodeURIComponent(username)}&&organizationId=${encodeURIComponent(organizationId)}`;
    const headers: HttpHeaders = new  HttpHeaders( {'content-type': 'application/json'});
    const result = await this.httpClient.get<string[]>(requestUrl, { headers}).toPromise();
   // console.log("result prajna",result);
    const configs = new Array<DataRefineryConfig>();
    //console.log("configs prajna",configs);
    result.forEach( json => {
        try {
          const config: DataRefineryConfig = DataRefineryConfig.fromJSON(JSON.parse(json));
          configs.push(config);
        } catch (err) {
          //console.log('Failed to deserialize config json: ' + json);
        }
      }
    );
    ////console.log('Received configs!');
   //console.log("data from API=",configs);

    return configs;

    //return result;
  }
  async getRefineryConfigByGuidAsync(configGuid: string): Promise<DataRefineryConfig> {
    const requestUrl = `${this.environmentService.activeAppBaseUrl}/api/Config/refineryConfig/${configGuid}`;
    const headers: HttpHeaders = new  HttpHeaders( {'content-type': 'application/json'});
    const result = await this.httpClient.get<string>(requestUrl, { headers}).toPromise();
    const config: DataRefineryConfig = DataRefineryConfig.fromJSON(result);
    this.userData.setSelectedRefineryDetails(config);
    return config;
  }
  async deleteRefineryConfigByGuid(guid: string): Promise<boolean> {
    //console.log(`Deleting config : ${guid}`);

    const requestUrl = `${this.environmentService.activeAppBaseUrl}/api/Config/refineryConfig/${guid}`;
    const headers: HttpHeaders = new  HttpHeaders( {'content-type': 'application/json'});
    const result = this.httpClient.delete<boolean>(requestUrl, { headers}).toPromise();

    return result;
  }
  async getFarmMappingConfigs(farmtype: number): Promise<FarmConverterRule[]> {
    const requestUrl = `${this.environmentService.activeAppBaseUrl}/api/Config/farmconfig/${farmtype}`;
    const headers: HttpHeaders = new  HttpHeaders( {'content-type': 'application/json'});
    const result = await this.httpClient.get<FarmConverterRule[]>(requestUrl, { headers}).toPromise();
    return result;
  }
  async getMasterConfigs(): Promise<MasterConfig> {
    const requestUrl = `${this.environmentService.activeAppBaseUrl}/api/Config/masterconfig`;
    const headers: HttpHeaders = new  HttpHeaders( {'content-type': 'application/json'});
    const result = await this.httpClient.get<MasterConfig>(requestUrl, { headers}).toPromise();
    return MasterConfig.fromJSON(result);
  }
  async exportDataFile(request: ExportViewModel): Promise<ExportDataFileResponse> {

    const body = JSON.stringify( request );
    ////console.log('Sending body - exportDataFile: ' + body);

    const requestUrl = `${this.environmentService.activeEngineBaseUrl}/api/v1.0/engine/exportdatafile`;
    const headers: HttpHeaders = new  HttpHeaders( {'content-type': 'application/json'});
    const result = await this.httpClient.post<ExportDataFileResponse>(requestUrl, body, { headers}).toPromise();

    return result;
  }
  async getDataWriterConfig(): Promise<any[]> {
    const requestUrl = `${this.environmentService.activeAppBaseUrl}/api/Config/datawriterconfig`;
    const headers: HttpHeaders = new  HttpHeaders( {'content-type': 'application/json'});
    const result = await this.httpClient.get<any[]>(requestUrl, { headers}).toPromise();
    return result;
  }
  async dataWriterTestConnection(request: TestDataWriterRequest): Promise<TestDataWriterResponse> {

    const body = JSON.stringify( request );
    //console.log('Sending body - testconnection: ' + body);

    const requestUrl = `${this.environmentService.activeEngineBaseUrl}/api/v1.0/refinery/testconnection`;
    const headers: HttpHeaders = new  HttpHeaders( {'content-type': 'application/json'});
    const result = await this.httpClient.post<TestDataWriterResponse>(requestUrl, body, { headers}).toPromise();
    ////console.log('result: ' + JSON.stringify(result));
    return result;
  }
  async getColumnsDWV2(request: DataWriterMapRequest): Promise<OutputCoulumnsMappingsResponse> {

    const body = JSON.stringify( request );
    //console.log('Sending body - testconnection: ' + body);

    const requestUrl = `${this.environmentService.activeEngineBaseUrl}/api/v1.0/refinery/getColumnsDWV2`;
    const headers: HttpHeaders = new  HttpHeaders( {'content-type': 'application/json'});
    const result = await this.httpClient.post<OutputCoulumnsMappingsResponse>(requestUrl, body, { headers}).toPromise();
    ////console.log('result: ' + JSON.stringify(result));
    return result;
  }
  async getoutputcolumns(request: OutputCoulumnRequest): Promise<OutputCoulumnResponse> {

    const body = JSON.stringify( request );
    //console.log('Sending body - getoutputcolumns: ' + body);

    const requestUrl = `${this.environmentService.activeEngineBaseUrl}/api/v1.0/engine/outputcolumns`;
    const headers: HttpHeaders = new  HttpHeaders( {'content-type': 'application/json'});
    const result = await this.httpClient.post<OutputCoulumnResponse>(requestUrl, body, { headers}).toPromise();
    //console.log('result getoutputcolumns: ' + JSON.stringify(result));
    return result;
  }
  async getpartitioncolumns(request: PartitionCoulumnRequest): Promise<PartitionCoulumnResponse> {

    const body = JSON.stringify( request );
    //console.log('Sending body - getoutputcolumns: ' + body);

    const requestUrl = `${this.environmentService.activeEngineBaseUrl}/api/v1.0/engine/partitioncols`;
    const headers: HttpHeaders = new  HttpHeaders( {'content-type': 'application/json'});
    const result = await this.httpClient.post<PartitionCoulumnResponse>(requestUrl, body, { headers}).toPromise();
    //console.log('result getoutputcolumns: ' + JSON.stringify(result));
    return result;
  }
  async testWriter(request: TestWriterRequest): Promise<TestDataWriterResponse> {

    const body = JSON.stringify( request );
    ////console.log('Sending body - testWriter: ' + body);

    const requestUrl = `${this.environmentService.activeEngineBaseUrl}/api/v1.0/refinery/testwriter`;
    const headers: HttpHeaders = new  HttpHeaders( {'content-type': 'application/json'});
    const result = await this.httpClient.post<TestDataWriterResponse>(requestUrl, body, { headers}).toPromise();
    ////console.log('result: ' + JSON.stringify(result));
    return result;
  }
  async getJoinerList(request: JoinerListRequest): Promise<JoinerListResponse[]> {

    const body = JSON.stringify( request );
    //console.log('Sending body - getoutputcolumns: ' + body);

    const requestUrl = `${this.environmentService.activeEngineBaseUrl}/api/v1.0/refinery/getJoinerList`;
    const headers: HttpHeaders = new  HttpHeaders( {'content-type': 'application/json'});
    const result = await this.httpClient.post<JoinerListResponse[]>(requestUrl, body, { headers}).toPromise();
    //console.log('result getJoinerList: ' + JSON.stringify(result));
    return result;
  }

    // Update the Ingest Node Status
    async updateIngestNodeStatus(updateIngestNodeStatusRequest: UpdateIngestNodesStatusRequest): Promise<UpdateIngestNodeStatusResponse> {
      const requestUrl = `${this.environmentService.activeEngineBaseUrl}/api/v1.0/engine/changeIngestNodeStatus`;
      const headers: HttpHeaders = new  HttpHeaders( {'content-type': 'application/json'});
  
      const body = JSON.stringify(updateIngestNodeStatusRequest);
      //console.log('Reset Refinery Send Param: ' + body);
  
      const result = await this.httpClient.post<UpdateIngestNodeStatusResponse>(requestUrl, body, { headers}).toPromise();
      return result;
    }
  async testEmail(request: TestSendEmailRequest): Promise<TestSendEmailResponse> {
    const body = JSON.stringify( request );
    console.log('Sending body - testEmail: ' + body);
    const requestUrl = `${this.environmentService.activeAppBaseUrl}/api/Email/sendemail`;
    const headers: HttpHeaders = new  HttpHeaders( {'content-type': 'application/json'});
    try {
      const result = await this.httpClient.post<TestSendEmailResponse>(requestUrl, body, { headers}).toPromise();
      console.log('testEmail result: ' + JSON.stringify(result));
      return result;
    } catch (error) {
      console.error('HTTP error:', error);
      throw error;
    }
  }
  async getSummaryDataFarm(request: GetSummaryDataFarmPreviewRequest): Promise<GetDataFarmPreviewResponse> {
    //console.log('running getInputDataForNode...');
    const body = JSON.stringify(request);
    //console.log('Sending body getInputDataForNode: ' + body);

    const requestUrl = `${this.environmentService.activeEngineBaseUrl}/api/v1.0/engine/getDataPreviewSummary`;
    const headers: HttpHeaders = new  HttpHeaders( {'content-type': 'application/json'});
    const result = this.httpClient.post<GetDataFarmPreviewResponse>(requestUrl, body, { headers}).toPromise();

    return result;
  }
  async getSummaryEmptyColslist(request: GetSummaryDataFarmPreviewRequest): Promise<GetSummaryEmptyColslistResponse> {
    //console.log('running getInputDataForNode...');
    const body = JSON.stringify(request);
    //console.log('Sending body getInputDataForNode: ' + body);

    const requestUrl = `${this.environmentService.activeEngineBaseUrl}/api/v1.0/engine/getEmptyColslist`;
    const headers: HttpHeaders = new  HttpHeaders( {'content-type': 'application/json'});
    const result = this.httpClient.post<GetSummaryEmptyColslistResponse>(requestUrl, body, { headers}).toPromise();

    return result;
  }

   async saveCurrentTransformerCache(saveCurntTransfrmCacheRequest: SaveCurrntTransfrmcacheRequest): Promise<SaveCurrntTransfrmcacheResponse> {
    const requestUrl = `${this.environmentService.activeEngineBaseUrl}/api/v1.0/engine/saveCurrentTransformerCache`;
    const headers: HttpHeaders = new  HttpHeaders( {'content-type': 'application/json'});

    const body = JSON.stringify(saveCurntTransfrmCacheRequest);
    //console.log('Reset Refinery Send Param: ' + body);

    const result = await this.httpClient.post<SaveCurrntTransfrmcacheResponse>(requestUrl, body, { headers}).toPromise();
    return result;
  }

  async getresetRefineryNodesStatus(request: ResetRefineryNodesStatusRequest): Promise<ResetRefineryNodesStatusResponse> {
    //console.log('running getInputDataForNode...');
    const body = JSON.stringify(request);
    //console.log('Sending body getInputDataForNode: ' + body);

    const requestUrl = `${this.environmentService.activeEngineBaseUrl}/api/v1.0/engine/resetRefineryNodesStatus`;
    const headers: HttpHeaders = new  HttpHeaders( {'content-type': 'application/json'});
    const result = this.httpClient.post<ResetRefineryNodesStatusResponse>(requestUrl, body, { headers}).toPromise();

    return result;
  }

  async getTransformersNodeStatus(request: ResetNodeStatusRequest): Promise<ResetNodeStatusResponse> {
    const body = JSON.stringify(request);

    const requestUrl = `${this.environmentService.activeEngineBaseUrl}/api/v1.0/engine/getTransformersNodeStatus`;
    const headers: HttpHeaders = new  HttpHeaders( {'content-type': 'application/json'});
    const result = this.httpClient.post<ResetNodeStatusResponse>(requestUrl, body, { headers}).toPromise();

    return result;
  }
  async getCacheStatus(request: CacheStatusRequest): Promise<CacheStatusResponse> {
    const body = JSON.stringify(request);

    const requestUrl = `${this.environmentService.activeEngineBaseUrl}/api/v1.0/engine/getCacheStatusForTransformer`;
    const headers: HttpHeaders = new  HttpHeaders( {'content-type': 'application/json'});
    const result = this.httpClient.post<CacheStatusResponse>(requestUrl, body, { headers}).toPromise();

    return result;
  }
  async purgeCache(request: CacheStatusRequest): Promise<CacheStatusResponse> {
    const body = JSON.stringify(request);

    const requestUrl = `${this.environmentService.activeEngineBaseUrl}/api/v1.0/engine/purgeTransformerCache`;
    const headers: HttpHeaders = new  HttpHeaders( {'content-type': 'application/json'});
    const result = this.httpClient.post<CacheStatusResponse>(requestUrl, body, { headers}).toPromise();

    return result;
  }
  /** {active: boolean, pid?: number, healthy?: boolean|null} -- healthy is
   * only meaningful when active is true; null means "can't measure", never
   * treat that as a safe-to-cancel signal. Used by the Cancel button to warn
   * before letting an Analyst cancel a run that's actually progressing fine. */
  async getRowWorkerProgressStatus(): Promise<{active: boolean, pid?: number, healthy?: boolean | null}> {
    const requestUrl = `${this.environmentService.activeEngineBaseUrl}/api/v1.0/engine/rowWorkerProgressStatus`;
    const result = this.httpClient.get<{active: boolean, pid?: number, healthy?: boolean | null}>(requestUrl).toPromise();

    return result;
  }
  /** The live, authoritative list of transform types with a real audit
   * adapter registered server-side (compiler_audit._ADAPTERS' own keys) --
   * the single source of truth for whether the Audit button should actually
   * work for a given type, rather than the frontend keeping its own
   * independently-maintained guess. */
  async getAuditableTypes(): Promise<{types: number[]}> {
    const requestUrl = `${this.environmentService.activeEngineBaseUrl}/api/v1.0/compiled/auditableTypes`;
    const result = this.httpClient.get<{types: number[]}>(requestUrl).toPromise();

    return result;
  }
  async getCompilableTypes(): Promise<{types: number[]}> {
    const requestUrl = `${this.environmentService.activeEngineBaseUrl}/api/v1.0/compiled/compilableTypes`;
    const result = this.httpClient.get<{types: number[]}>(requestUrl).toPromise();

    return result;
  }
  async cancelRowWorkerTask(): Promise<{message: string}> {
    const requestUrl = `${this.environmentService.activeEngineBaseUrl}/api/v1.0/engine/cancelRowWorkerTask`;
    const headers: HttpHeaders = new  HttpHeaders( {'content-type': 'application/json'});
    const result = this.httpClient.post<{message: string}>(requestUrl, '{}', { headers}).toPromise();

    return result;
  }
  async testFTPConnection(request: FtpService): Promise<TestFTPConnectionResponse> {
    const body = JSON.stringify(request);
    const requestUrl = `${this.environmentService.activeEngineBaseUrl}/api/v1.0/engine/testSFTPConnection`;
    const headers: HttpHeaders = new  HttpHeaders( {'content-type': 'application/json'});
    const result = this.httpClient.post<TestFTPConnectionResponse>(requestUrl, body, { headers}).toPromise();

    return result;
  }

  async getTotalPartitionedFolders(request: GetTotalPartitionedFoldersRequest): Promise<GetTotalPartitionedFoldersResponse> {

    const body = JSON.stringify( request );
    //console.log('Sending body - loadColumns: ' + body);

    const requestUrl = `${this.environmentService.activeEngineBaseUrl}/api/v1.0/engine/getTotalPartitionedFolders`;
    const headers: HttpHeaders = new  HttpHeaders( {'content-type': 'application/json'});
    const result = this.httpClient.post<GetTotalPartitionedFoldersResponse>(requestUrl, body, { headers}).toPromise();

    return result;
  }

  async getDefaultIngestNodePath(request: GetDefaultIngestNodePathRequest): Promise<GetDefaultIngestNodePathResponse> {
    const body = JSON.stringify( request );
    //console.log('Sending body - loadColumns: ' + body);

    const requestUrl = `${this.environmentService.activeEngineBaseUrl}/api/v1.0/engine/getDefaultIngestNodePath`;
    const headers: HttpHeaders = new  HttpHeaders( {'content-type': 'application/json'});
    const result = this.httpClient.post<GetDefaultIngestNodePathResponse>(requestUrl, body, { headers}).toPromise();

    return result;
  }

  async setDefaultIngestNodePath(request: SetDefaultIngestNodePathRequest): Promise<GetDefaultIngestNodePathResponse> {
    const body = JSON.stringify( request );

    const requestUrl = `${this.environmentService.activeEngineBaseUrl}/api/v1.0/engine/setDefaultIngestNodePath`;
    const headers: HttpHeaders = new  HttpHeaders( {'content-type': 'application/json'});
    const result = this.httpClient.post<GetDefaultIngestNodePathResponse>(requestUrl, body, { headers}).toPromise();

    return result;
  }

  async getDefaultParquetPartitionedIngestNodePath(request: GetDefaultParquetPartitionedIngestNodePathRequest): Promise<GetDefaultIngestNodePathResponse> {
    const body = JSON.stringify( request );
    //console.log('Sending body - loadColumns: ' + body);

    const requestUrl = `${this.environmentService.activeEngineBaseUrl}/api/v1.0/engine/getDefaultParquetPartitionedIngestNodePath`;
    const headers: HttpHeaders = new  HttpHeaders( {'content-type': 'application/json'});
    const result = this.httpClient.post<GetDefaultIngestNodePathResponse>(requestUrl, body, { headers}).toPromise();

    return result;
  }

  async validateParquetPartitionedIngestNodePath(request: ValidateParquetPartitionedIngestNodePathRequest): Promise<ValidateParquetPartitionedIngestNodePathResponse> {
    const body = JSON.stringify( request );
    //console.log('Sending body - loadColumns: ' + body);

    const requestUrl = `${this.environmentService.activeEngineBaseUrl}/api/v1.0/engine/validateParquetPartitionedIngestNodePath`;
    const headers: HttpHeaders = new  HttpHeaders( {'content-type': 'application/json'});
    const result = this.httpClient.post<ValidateParquetPartitionedIngestNodePathResponse>(requestUrl, body, { headers}).toPromise();

    return result;
  }

  async streamPost<TRequest, TResponse>(
    url: string,
    payload: TRequest,
    onMessage: (msg: TResponse) => void,
    signal?: AbortSignal
  ): Promise<TResponse | null> {
    // A run is a server-side job (docs/Run_Job_Architecture.md): this request only FOLLOWS
    // it, and every line carries jobId + seq. If the connection drops before the final
    // message (network blip, sleep, proxy timeout), re-attach to the same job from the
    // next seq instead of failing -- the run never stopped. Callers see the same messages
    // in the same order, each exactly once.
    const response = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
      signal
    });
    if (!response.body) {
      throw new Error("No response body from API");
    }
    return this.followRunStream<TResponse>(response, url.substring(0, url.indexOf('/api/')), null, onMessage, signal);
  }

  /** Follows a run job that is already running on the server -- e.g. one started before
   * this page was (re)loaded -- from its first message, exactly as streamPost would. */
  async followRunJob<TResponse>(jobId: string, onMessage: (msg: TResponse) => void, signal?: AbortSignal): Promise<TResponse | null> {
    const apiBase = this.environmentService.activeEngineBaseUrl;
    const response = await fetch(`${apiBase}/api/v1.0/runjobs/${jobId}/events?from=0`, { signal });
    if (response.status === 404) {
      return null;   // finished and expired, or the server restarted
    }
    return this.followRunStream<TResponse>(response, apiBase, jobId, onMessage, signal);
  }

  /** Asks the server to cancel a run job. It stops before its next step (a Run Refinery
   * finishes the node in progress first) and ends with a "cancelled" message. */
  async cancelRunJob(jobId: string): Promise<void> {
    const apiBase = this.environmentService.activeEngineBaseUrl;
    const response = await fetch(`${apiBase}/api/v1.0/runjobs/${jobId}/cancel`, { method: 'POST' });
    if (!response.ok) {
      throw new Error("The run could not be cancelled -- it may already have finished.");
    }
  }

  /** Every run job in progress on the server (any refinery, any user) -- the Refinery
   * list marks those refineries "Running". */
  async getAllActiveRunJobs(): Promise<any[]> {
    const apiBase = this.environmentService.activeEngineBaseUrl;
    const response = await fetch(`${apiBase}/api/v1.0/runjobs/active`);
    if (!response.ok) { return []; }
    const body = await response.json();
    return body?.jobs ?? [];
  }

  /** Run jobs this user has in progress for a refinery (Run Refinery / Run Node). */
  async getActiveRunJobs(refineryId: string, userId: number | string): Promise<any[]> {
    const apiBase = this.environmentService.activeEngineBaseUrl;
    const response = await fetch(`${apiBase}/api/v1.0/runjobs/active?refineryId=${encodeURIComponent(refineryId)}&userId=${encodeURIComponent(String(userId))}`);
    if (!response.ok) { return []; }
    const body = await response.json();
    return body?.jobs ?? [];
  }

  /** Reads a run job's stream, re-attaching from the next seq whenever it drops before the
   * final message (see streamPost). */
  private async followRunStream<TResponse>(
    firstResponse: Response,
    apiBase: string,
    knownJobId: string | null,
    onMessage: (msg: TResponse) => void,
    signal?: AbortSignal
  ): Promise<TResponse | null> {
    const state = { jobId: knownJobId, lastSeq: -1, final: null as TResponse | null };
    const retryDelaysMs = [1000, 2000, 4000, 8000, 15000, 30000, 30000, 30000];
    let response: Response | null = firstResponse;

    for (let attempt = 0; ; attempt++) {
      let streamError: any = null;
      try {
        if (response && response.ok && response.body) {
          if (await this.readRunStream(response, onMessage, state)) {
            return state.final;
          }
        }
      } catch (err) {
        streamError = err;
      }
      // The page stopped following (it opened another refinery): the run itself goes on.
      if (signal?.aborted) {
        return null;
      }
      // The stream ended without its final message. Only a job can be re-attached.
      if (!state.jobId || attempt >= retryDelaysMs.length) {
        if (streamError) { throw streamError; }
        return state.final;
      }
      console.warn(`Run stream interrupted; re-attaching to job ${state.jobId} from seq ${state.lastSeq + 1}`, streamError);
      await new Promise(resolve => setTimeout(resolve, retryDelaysMs[attempt]));
      try {
        response = await fetch(`${apiBase}/api/v1.0/runjobs/${state.jobId}/events?from=${state.lastSeq + 1}`, { signal });
        if (response.status === 404) {
          throw new Error("The run is no longer available on the server (it may have been restarted).");
        }
      } catch (err) {
        if (signal?.aborted) { return null; }
        if (err instanceof Error && err.message.startsWith("The run is no longer available")) { throw err; }
        response = null;   // server unreachable this time -- try again after the next delay
      }
    }
  }

  /** Reads one run stream; true once the final (finished / fatal_error) message arrived. */
  private async readRunStream<TResponse>(
    response: Response,
    onMessage: (msg: TResponse) => void,
    state: { jobId: string | null, lastSeq: number, final: TResponse | null }
  ): Promise<boolean> {
    const reader = response.body!.getReader();
    const decoder = new TextDecoder();
    let buffer = '';
    try {
      while (true) {
        const { done, value } = await reader.read();
        if (done) { return false; }

        buffer += decoder.decode(value, { stream: true });
        const lines = buffer.split('\n');
        buffer = lines.pop() || '';

        for (const line of lines) {
          if (!line.trim()) continue;

          let msg: TResponse;
          try {
            msg = JSON.parse(line) as TResponse;
          } catch (err) {
            console.error("Invalid JSON line:", line, err);
            continue;
          }
          const tagged = msg as any;
          if (tagged.jobId) { state.jobId = tagged.jobId; }
          if (typeof tagged.seq === 'number') {
            if (tagged.seq <= state.lastSeq) { continue; }   // already delivered before a re-attach
            state.lastSeq = tagged.seq;
          }

          // callback for UI updates (progress)
          onMessage(msg);

          // The finished/fatal_error line IS completion — stop reading as soon as we
          // see it rather than waiting for the underlying stream to also signal done.
          // Waiting on both left this hung indefinitely whenever the server's response
          // was already fully delivered but the reader never observed a close (seen in
          // practice: server access log shows 200, but this loop never returned) —
          // that stuck await then blocked every subsequent Copilot-triggered run behind
          // the in-flight guard, with no exception and no further network activity.
          if (tagged.status === 'finished' || tagged.status === 'fatal_error' || tagged.status === 'cancelled') {
            state.final = msg;
            return true;
          }
        }
      }
    } finally {
      reader.cancel().catch(() => {});
    }
  }
//Usage Example
// this.streamPost<RunRefineryRequest, RunRefineryResponse>(
//   requestUrl,
//   runRefineryRequest,
//   (msg) => {
//     console.log("Progress message:", msg);
//     this.progressUpdates.push(msg);
//   }
// ).then(result => {
//   console.log("Final result:", result);
// });
//OR/OR/OROR/
// let runNodeResponse: RunrefineryResponse | null = null;
// runNodeResponse=await this.configService.streamPost<RunrefineryRequest, RunrefineryResponse>(
//   requestUrl,
//   runNodeRequest,
//   (msg) => {
//     console.log("Progress message:", msg);
//     this.progressUpdates.push(msg);
//   }
// );

}